
import { AxiosResponse, AxiosError } from 'axios'
import { useToast } from "vue-toastification";
import { Options, Vue } from 'vue-class-component';
import AnagramService from '@/services/AnagramService';

@Options({
  props: {
    msg: String
  }
})
export default class AnagramInput extends Vue {
  input: string = "";
  result: any = null;
  toast: any;

  created() {
    this.toast = useToast();
  }

  getData() {
    AnagramService.getAnagrams(this.input).then((response: AxiosResponse) => {
      this.result = response;
      if (!Object.entries(response).length) {
        this.toast.warning('No results.');
      }
    }).catch((e: AxiosError) => {
      if (e.response!.status === 400) {
        this.toast.warning(e.response!.data);
      }
      console.log(e);
    });
  }
}
